module.exports = "https://cdn.prod.zoopla.co.uk/_next/static/images/landing-pages-hill-5f385d9e9cb6701f9941152d1bf956ec.svg";